module.exports = __webpack_public_path__ + "static/media/4c5113af-3402-4eb0-8a1e-59b38d4c4dc6.db5582d7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/4c5113af-3402-4eb0-8a1e-59b38d4c4dc6.ttf
// module id = 81
// module chunks = 0